export default {
  title: 'لیست سفارشات',
  search:'جستجو ...',
  id: 'شناسه',
  studentName: 'دانش آموز',
  studentMobile: 'موبایل',
  subtotal: 'مبلغ کل',
  totalDiscount: 'جمع تخفیف',
  totalPrice: 'مبلغ نهایی',
  shippingMethod: 'روش ارسال',
  paymentMethod: 'روش پرداخت',
  status: 'وضعیت',
  statusRegistered: 'ثبت شده',
  statusApproved: 'تایید شده',
  
  changeStatus: "تغییر وضعیت سفارش",
  confirm: "تایید",
  cancel: "انصراف",
  approveOrder: "تایید سفارش",
  rejectOrder: "رد سفارش",
  changeStatusBtn: "تغییر وضعیت",

  statusRejected: 'رد شده',
  loading:'در حال دریافت اطلاعات ...',
  operating:'عملیات',
  empty:'داده ای یافت نشد',
  success:'موفق',
  deleteConfirm:'آیا از حذف این محصول مطمئن هستید؟'




}
